import { axiosClassic } from '@/api/interceptors'
import { CheckedKeys } from '@/utils/checked-keys/CheckedKeys'
import {
	PropsOfferList,
	PropsSearchTours
} from './SearchToursService.interface'

export const SearchToursService = {
	async getSearchTours({
		townFrom,
		countryCode,
		adult,
		child = 0,
		childs_age,
		price_range_min = 100,
		price_range_max = 10000,
		meal_types = ['AL', 'BB'],
		nights_max,
		nights_min,
		rating = [true, true, true, true, true],
		sort,
		data,
		date_check_range,
		beach,
		for_kids,
		for_active_rest,
		page = 1
	}: PropsSearchTours) {
		window.scrollTo(0, 300)
		const response = await axiosClassic.get('/search-tours', {
			params: {
				townFrom,
				countryCode,
				adults: adult,
				childs: child,
				childs_age: String(childs_age) || '',
				price_range_min,
				price_range_max,
				meal_types: String(meal_types),
				nights_max,
				nights_min,
				rating: CheckedKeys(rating),
				sort,
				data: data.split('-').join(''),
				date_check_range,
				beach,
				for_kids,
				for_active_rest,
				page
			}
		})
		return response
	},
	async getOfferList({
		townFrom,
		hotelCode,
		adult,
		child = 0,
		childs_age,
		price_range_min = 100,
		price_range_max = 10000,
		meal_types = ['AL', 'BB'],
		nights_max,
		nights_min,
		rating = [true, true, true, true, true],
		data,
		date_check_range
	}: PropsOfferList, newDate: string | null, firstDateAvailable: string) {
		const response = await axiosClassic.get('/offers-list', {
			params: {
				townFrom: townFrom==''?'lv':townFrom,
				hotelCode,
				adults: adult,
				childs: child,
				childs_age: String(childs_age),
				price_range_min,
				price_range_max,
				meal_types: `[${String(meal_types)}]`,
				nights_max,
				nights_min,
				rating: CheckedKeys(rating),
				//data: data.split('-').join('')
				data: newDate?.split('-').join('') ? newDate?.split('-').join('') : firstDateAvailable,
				date_check_range
			}
		})
		return response
	},
	async getHotel({ id }: { id: string }) {
		const response = axiosClassic.get(`hotel/${id}`)
		return response
	},
	async getHotelName(searchString: string) {
		const response = axiosClassic.get(`search-hotel`, {
			params: {
				searchString
			}
		})
		return response
	},
	async getPopular() {
		const response = axiosClassic.get(`popular-hotel`)
		return response
	},
	async getBest() {
		const response = axiosClassic.get(`best-hotel`)
		return response
	},
	async getOffer(data:any){
		const response = axiosClassic.post('get-offer-form',data)
	},
	async getOffer_ru(data:any){
		const response = axiosClassic.post('get-offer-form-ru',data)
	}
}
